
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotos",
      function () {
        return require("private-next-pages/fotos/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotos"])
      });
    }
  